import { Button } from '@mui/material';
import { useMemo } from 'react';

import { Icon } from '@hapvida/hapvida-core-components';

import { CircularProgress } from '@hapvida/hapvida-core-components/src/components/CircularProgress';
import { NEW_COLORS } from '@hapvida/hapvida-core-components/src/themes/colors/newColors';

import type { ButtonInfoMemoProps } from './types';
import { useExportCopartPreviewFile } from './useExportCopartPreviewFile';

export function CopartPreviewExportButton() {
  const {
    isExportingCopartPreviewFile,
    handleDownloadCopartPreviewFile,
    isReadyToDownload,
    handleExportCopartPreviewFile,
  } = useExportCopartPreviewFile();

  const exportButtonText = (() => {
    if (isExportingCopartPreviewFile) {
      return 'Gerando arquivo';
    }

    if (isReadyToDownload) {
      return 'Download CSV';
    }

    return 'Gerar arquivo CSV';
  })();

  const buttonInfoMemo: ButtonInfoMemoProps = useMemo(() => {
    if (isReadyToDownload) {
      return {
        buttonVariant: 'contained',
        buttonColor: 'success',
        iconName: 'actions-b2b-download',
        onClick: handleDownloadCopartPreviewFile,
      };
    }
    return {
      buttonVariant: 'outlined',
      buttonColor: 'primary',
      iconName: 'presentation-b2b-file-excell',
      onClick: handleExportCopartPreviewFile,
    };
  }, [
    isReadyToDownload,
    handleDownloadCopartPreviewFile,
    handleExportCopartPreviewFile,
  ]);

  const iconColor = useMemo(() => {
    if (isReadyToDownload) {
      return NEW_COLORS.BASE.WHITE;
    }
    return NEW_COLORS.PRIMARY[500];
  }, [isReadyToDownload]);

  const { buttonColor, buttonVariant, iconName, onClick } = buttonInfoMemo;

  return (
    <Button
      onClick={onClick}
      disabled={isExportingCopartPreviewFile}
      variant={buttonVariant}
      color={buttonColor}
      fullWidth
      endIcon={
        isExportingCopartPreviewFile ? (
          <CircularProgress
            progressColor={NEW_COLORS.GRAYSCALE[700]}
            size={16}
          />
        ) : (
          <Icon name={iconName} size={20} color={iconColor} />
        )
      }
    >
      {exportButtonText}
    </Button>
  );
}
